import ApiClient from './ApiClient';
import PortOpeningRequestOnPrem from '../models/entities/PortOpeningRequestOnPrem';
import SubmitPortOpeningRequestOnPrem from '../models/viewModels/OnPremPortOpeningRequests/SubmitPortOpeningRequestOnPrem';
import ApprovePortOpeningRequestOnPrem from '../models/viewModels/OnPremPortOpeningRequests/ApprovePortOpeningRequestOnPrem';
import PortOpeningRequestService from './PortOpeningRequestService';
import NetworkConnection from '../models/entities/NetworkConnection';

export default class OnPremPortOpeningRequestService extends ApiClient {

	portOpeningRequestService: PortOpeningRequestService;

	constructor() {
		super();
		this.portOpeningRequestService = new PortOpeningRequestService();
	}

	async getAll() {
		return this.get<PortOpeningRequestOnPrem[]>('OnPremPortOpeningRequests');
	}

	async getById(id: number) {
		return this.get<PortOpeningRequestOnPrem>(`OnPremPortOpeningRequests/${id}`);
	}

	async getMyApprovals() {
		return this.get<PortOpeningRequestOnPrem[]>('OnPremPortOpeningRequests/myApprovals');
	}

	async getNCDBbyTrackerId(trackerId: number) {
		return this.get<NetworkConnection>(`OnPremPortOpeningRequests/ncdb/${trackerId}`);
	}

	async create(por: SubmitPortOpeningRequestOnPrem) {
		return this.post<PortOpeningRequestOnPrem>('OnPremPortOpeningRequests', por);
	}

	async verifyApproverLevel(email: string, isEmergency: boolean) {
		return await this.portOpeningRequestService.verifyApproverLevel(email, isEmergency);
	}

	async doReviewal( review: ApprovePortOpeningRequestOnPrem, id: number) {
		return this.patch<PortOpeningRequestOnPrem>(`OnPremPortOpeningRequests/${id}/reviewal`, review);
	}

	async doApproval( approve: ApprovePortOpeningRequestOnPrem, id: number) {
		return this.patch<PortOpeningRequestOnPrem>(`OnPremPortOpeningRequests/${id}/approval`, approve);
	}

	async doComplete( complete: ApprovePortOpeningRequestOnPrem, id: number) {
		return this.patch<PortOpeningRequestOnPrem>(`OnPremPortOpeningRequests/${id}/completion`, complete);
	}
}